import React, { memo } from "react";
import { Box, Chip, Typography } from "@mui/material";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { Handle } from "react-flow-renderer";

const operatorLabel = op => {
  const map = {
    equals: "==",
    notEquals: "!=",
    contains: "contem",
    startsWith: "inicia com",
    endsWith: "termina com",
    greaterThan: ">",
    lessThan: "<",
    greaterOrEqual: ">=",
    lessOrEqual: "<=",
    isEmpty: "vazio",
    isNotEmpty: "nao vazio"
  };

  return map[op] || op;
};

export default memo(({ data, isConnectable }) => {
  const leftValue = data?.leftValue || "";
  const rightValue = data?.rightValue || "";
  const operator = data?.operator || "equals";
  const isUnary = operator === "isEmpty" || operator === "isNotEmpty";

  return (
    <Box
      sx={{
        width: 300,
        backgroundColor: "#fff",
        border: "1px solid rgba(25, 118, 210, 0.22)",
        borderRadius: 2,
        boxShadow: 2,
        p: 1.5,
        position: "relative"
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          left: -8,
          top: "50%",
          transform: "translateY(-50%)",
          background: "#1976d2",
          width: 12,
          height: 12
        }}
        isConnectable={isConnectable}
      />

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <CompareArrowsIcon fontSize="small" sx={{ color: "#1976d2" }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Comparacao
        </Typography>
      </Box>

      <Box sx={{ mb: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Valor 1
        </Typography>
        <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
          {leftValue || "-"}
        </Typography>
      </Box>

      <Box sx={{ mb: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Operador
        </Typography>
        <Box>
          <Chip size="small" label={operatorLabel(operator)} sx={{ mt: 0.5 }} />
        </Box>
      </Box>

      {!isUnary && (
        <Box sx={{ mb: 1 }}>
          <Typography variant="caption" color="text.secondary">
            Valor 2
          </Typography>
          <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
            {rightValue || "-"}
          </Typography>
        </Box>
      )}

      <Handle
        type="source"
        position="right"
        id="true"
        style={{
          right: -8,
          top: 26,
          background: "#2e7d32",
          width: 12,
          height: 12
        }}
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        position="right"
        id="false"
        style={{
          right: -8,
          bottom: 26,
          top: "auto",
          background: "#d32f2f",
          width: 12,
          height: 12
        }}
        isConnectable={isConnectable}
      />

      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
        <Typography variant="caption" sx={{ color: "#2e7d32", fontWeight: 700 }}>
          true
        </Typography>
        <Typography variant="caption" sx={{ color: "#d32f2f", fontWeight: 700 }}>
          false
        </Typography>
      </Box>
    </Box>
  );
});
